import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import styles from '../../styles/views/components/SpringBottom.module.scss';

const BOTTOM_SHEET_SNAP_TOP = 110;
const BOTTOM_SHEET_SNAP_BOTTOM = 70;

const SpringBottom = ({ content }) => {
  const [indexOfActiveTab, setIndexOfActiveTab] = useState(0);
  const [isBottomSheetOpen] = useState(true);
  const [isBottomSheetExpanded, setIsBottomSheetExpanded] = useState(false);
  const bottomSheetRef = React.useRef(null);
  const containerRef = React.useRef(null);

  const handleDismiss = () => {
    if (isBottomSheetExpanded) {
      setIsBottomSheetExpanded(false);
    } else {
      bottomSheetRef.current.snapTo(0);
    }
  };

  const handleSheetSpringStart = () => {
    setIsBottomSheetExpanded(true);
  };

  const handleOverlayClick = (event) => {
    const containerElement = containerRef.current;
    if (containerElement) {
      const rect = containerElement.getBoundingClientRect();
      const { top, bottom } = rect;
      const { clientY, target } = event;
      const isInsideContent = target.closest('.bottom-sheet-content');
      if ((clientY < top || clientY > bottom) && !isInsideContent) {
        setIsBottomSheetExpanded(false);
        bottomSheetRef.current.snapTo(1);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOverlayClick);
    return () => {
      document.removeEventListener('click', handleOverlayClick);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <BottomSheet
        expandOnContentDrag
        ref={bottomSheetRef}
        open={isBottomSheetOpen}
        snapPoints={({ maxHeight }) => [
          maxHeight - BOTTOM_SHEET_SNAP_TOP,
          maxHeight - (maxHeight - BOTTOM_SHEET_SNAP_BOTTOM),
        ]}
        onDismiss={handleDismiss}
        blocking={!isBottomSheetExpanded}
        onSpringStart={handleSheetSpringStart}
        initialFocusRef={false}
      >
        <div className="bottom-sheet-content">
          <div className={styles.wrapper}>
            <div className={styles.header}>
              {content.map(({ title, subTitle }, index) => (
                <div
                  key={`TitleTab${title}`}
                  className={`${styles.titleTab} ${indexOfActiveTab === index ? '' : styles.unActiveTitle}`}
                  onClick={() => setIndexOfActiveTab(index)}
                >
                  <div className={`${styles.titleWrapper} ${index > 0 ? styles.devider : ''}`}>
                    <span>{title}</span>
                    {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.content}>
              {content.map(({ tab, title }, index) => (
                <div
                  key={`ContentTab${title}`}
                  className={`${indexOfActiveTab === index ? styles.activeContentTab : styles.unActiveContentTab}`}
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

SpringBottom.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    tab: PropTypes.node,
  })).isRequired,
};

export default SpringBottom;
